import { Auth } from 'aws-amplify';
import React from 'react';
import { createRoot } from 'react-dom/client';

import ReactRoot from './ReactRoot';
import env from './env';
import { datadogLogs, datadogRum } from './logging/datadog';
import './tailwind.css';
import clearLegacySsoCookies from './util/clearLegacySsoCookies';
import getAppVersion from './util/getAppVersion';
import './v2/styles/theme.css';

console.log('version: ', getAppVersion());
console.log('env: ', env.NODE_ENV, process.env.NODE_ENV);

// Clear legacy parent-domain Cognito cookies from the previous cookie-based SSO approach
clearLegacySsoCookies();

Auth.configure({
  userPoolId: env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  userPoolWebClientId: env.REACT_APP_AWS_COGNITO_USER_POOL_WEBCLIENT_ID,
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  federationTarget: 'COGNITO_USER_POOLS',
});

if (env.REACT_APP_DATADOG_RUM_ENABLED) {
  datadogRum.get().catch(console.error);
} else {
  console.log('DATADOG RUM disabled');
}

if (env.REACT_APP_DATADOG_LOG_ENABLED) {
  datadogLogs.get().catch(console.error);
} else {
  console.log('DATADOG LOGS disabled');
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<ReactRoot />);
